import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Loader } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import LeadCaptureModal from '../components/LeadCaptureModal';
import SEO from '../components/SEO';

const ScanPage = () => {
  const navigate = useNavigate();
  const [showLeadModal, setShowLeadModal] = useState(false);

  const handleStartScan = () => {
    setShowLeadModal(true);
  };

  return (
    <div className="min-h-screen bg-[#0B0B0D] flex flex-col">
      <SEO
        title="Trust Signal Scan | Free Diagnostic — Subsurface"
        description="Run the free Trust Signal Scan. A 10-minute structured diagnostic across four failure domains, with an AI-generated trust report."
        path="/scan"
      />
      <Navigation />

      <div className="flex-1 pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="text-5xl md:text-6xl font-bold font-display mb-6">
              Trust Signal Scan
            </h1>
            <p className="text-lg text-[#A0A0A0] leading-relaxed">
              A 10-minute structured diagnostic across 4 trust domains to surface visible friction and trust gaps.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="glass-card p-12 rounded-lg text-center"
          >
            <p className="text-[#A0A0A0] mb-8">
              Click below to begin your discovery scan. You'll answer structured questions across Evidence Integrity, Identity Credibility, Operational Visibility, and Control Architecture.
            </p>
            
            <button
              onClick={handleStartScan}
              className="group px-8 py-4 bg-[#FF6A00] text-white font-semibold rounded-md hover:bg-[#FF6A00]/90 transition-all duration-300 shadow-[0_0_20px_rgba(255,106,0,0.3)] hover:shadow-[0_0_30px_rgba(255,106,0,0.5)] flex items-center gap-2 mx-auto"
            >
              Start Discovery Scan
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>

            <p className="text-sm text-[#A0A0A0] mt-8">
              This is a surface-level discovery.<br />
              <span className="text-white">Full Trust & Revenue Integrity Review available on request.</span>
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-12 text-center"
          >
            <p className="text-sm text-[#A0A0A0] mb-4">Prefer a different route?</p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="/gateway" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Talk to Gateway
              </a>
              <a href="/submit" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Submit Details
              </a>
              <a href="/" className="text-sm text-[#FF6A00] hover:text-[#FF6A00]/80 transition-colors">
                Return Home
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />

      {showLeadModal && (
        <LeadCaptureModal
          isOpen={showLeadModal}
          onClose={() => setShowLeadModal(false)}
          modalType="diagnostic"
        />
      )}
    </div>
  );
};

export default ScanPage;
